<template>
  <div :class="$style.style">
    <div class="cropper-upload">
      <!-- 遮罩层 -->
      <div class="container" v-show="panel">
        <div>
          <img :id="'image'+ckey" class="image" :src="url" alt="Picture" />
        </div>
        <button type="button" class="button" @click="crop">确定</button>
        <button type="button" class="cancel" @click="cancel">取消</button>
      </div>
      <div>
        <div>
          <input type="file" :id="'change'+ckey" accept="image" @change="change" class="inputfile" ref="inputer">
          <label :for="'change'+ckey">
            <div :class="[ratio=='1'?'show1':'show2']">
              <div :class="[ratio=='1'?'picture-item1':'picture-item2', 'picture']" :style="'backgroundImage:url('+headerImage+')'">
                <i class="el-icon-plus" style="display: block;" v-show="!headerImage"></i>
                <span style="display: block;line-height:20px;" v-show="!headerImage">上传图片</span>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*!
* 裁剪控件：
* https://github.com/fengyuanchen/cropperjs
*
* 参考：https://blog.csdn.net/leileibrother/article/details/78655371
*
* 参数：长宽比：ratio '1' 16/9 样式 show1 213.33*120 ; '2' 1 样式 show2 120*120
*
*/
import Cropper from 'cropperjs';
import axios from 'axios';
import { Message } from 'element-ui';
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: String, default: '' },
    ratio: { type: String, default: '1' },
    ckey: { type: String, default: '' }
  },
  data() {
    return {
      headerImage: '',
      picValue: '',
      cropper: '',
      croppable: false,
      panel: false,
      url: '',
      imgCropperData: {
        accept: "image/gif, image/jpeg, image/png, image/jpg"
      }
    }
  },
  mounted() {
    //初始化这个裁剪框
    var self = this;

    var image = document.getElementById('image' + this.ckey);
    this.cropper = new Cropper(image, {
      aspectRatio: this.ratio == '1' ? 1.8 : 1,
      viewMode: 1,
      background: false,  // 方格背景
      zoomable: false,  // 能否缩放图片
      ready: function() {
        self.croppable = true;
      }
    });
  },
  watch: {
    value: function() {
      if (this.value == null || this.value == '') {
        this.headerImage = '';
      } else {
        this.headerImage = this.value;
      }
    }
  },
  methods: {
    //取消上传
    cancel() {
      this.panel = false;
      this.picValue = '';
      this.url = '';
      this.$refs.inputer.value = '';
    },
    getObjectURL(file) {
      var url = null;
      if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    //input框change事件，获取到上传的文件
    change(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      // 判断类型和大小
      // let type = files[0].type; //文件的类型，判断是否是图片
      let size = files[0].size; //文件的大小，判断图片的大小
      // if (this.imgCropperData.accept.indexOf(type) == -1) {
      //   alert("请选择我们支持的图片格式！");
      //   return false;
      // }
      if (size > 1024 * 1024) {
        // alert("请选择5M以内的图片！");
        this.$alert('请选择1M以内的图片！', '提示', {
          confirmButtonText: '知道了',
          center: true,
          showClose: false
        });
        return false;
      }

      this.picValue = files[0];

      this.url = this.getObjectURL(this.picValue);
      //每次替换图片要重新得到新的url
      if (this.cropper) {
        this.cropper.replace(this.url);
      }
      this.panel = true;

    },
    crop() {
      this.panel = false;
      var croppedCanvas;
      var roundedCanvas;
      if (!this.croppable) {
        return;
      }
      // Crop
      croppedCanvas = this.cropper.getCroppedCanvas();
      console.log(this.cropper)
      // Round
      // roundedCanvas = this.getRoundedCanvas(croppedCanvas);
      roundedCanvas = this.getRectCanvas(croppedCanvas);
      this.headerImage = roundedCanvas.toDataURL();
      this.postImg();
      this.$refs.inputer.value = '';
    },
    getRoundedCanvas(sourceCanvas) {  // 圆形
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;
      canvas.width = width;
      canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
      context.fill();
      return canvas;
    },
    getRectCanvas(sourceCanvas) {  // 矩形

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var width = sourceCanvas.width;
      var height = sourceCanvas.height;
      canvas.width = width;
      canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.drawImage(sourceCanvas, 0, 0, width, height);
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.rect(0, 0, width, height);
      context.fill();
      return canvas;
    },
    postImg() {
      //这边写图片的上传
      var data = new FormData();
      data.append('file', this.dataURLtoFile(this.headerImage, 'test.png'));
      axios
        .post('/upload', data, {
          headers: { 'Content-Type': 'multipart/form-data' } // application/json  application/x-www-form-urlencoded
        })
        .then(data => {
          console.log(data);
          this.$emit('change', data.list[0]);
        });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  }
}
</script>
<style lang="less" module>
:local(.style) {
  margin: 0;
  padding: 0;
  .cropper-upload .button {
    position: absolute;
    right: 100px;
    top: 10px;
    width: 80px;
    height: 40px;
    border: none;
    border-radius: 5px;
    background: white;
  }
  .cropper-upload .cancel {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 80px;
    height: 40px;
    border: none;
    border-radius: 5px;
    background: white;
  }
  .cropper-upload .show1 {
    width: 360px;
    height: 200px;
    overflow: hidden;
    position: relative; // border-radius: 50%;  //显示图形圆角
    // border: 1px dashed #D8DFE5;
    // border-radius: 4px;
  }
  .cropper-upload .show2 {
    width: 80px;
    height: 80px;
    overflow: hidden;
    position: relative; // border-radius: 50%;  //显示图形圆角
    // border: 1px solid #D8DFE5;
    // border-radius: 4px;
  }
  .cropper-upload .picture {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
  }
  .picture-item1 {
    line-height: 124px;
    padding-top: 90px;
  }
  .picture-item2 {
    line-height: 80px;
    padding-top: 25px;
  }
  .cropper-upload .container {
    z-index: 9999;
    position: fixed;
    padding-top: 60px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    overflow-y: auto;
    overflow-x: auto;
  }
  .cropper-upload .image {
    max-width: 100%;
  }
  .cropper-view-box,
  .cropper-face {
    // border-radius: 50%;  // 裁剪明亮图形圆角
  }
  .cropper-container {
    font-size: 0;
    line-height: 0;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    direction: ltr;
    -ms-touch-action: none;
    touch-action: none
  }

  .cropper-container img {
    /* Avoid margin top issue (Occur only when margin-top <= -height) */
    display: block;
    min-width: 0 !important;
    max-width: none !important;
    min-height: 0 !important;
    max-height: none !important;
    width: 100%;
    height: 100%;
    image-orientation: 0deg
  }
  .cropper-wrap-box,
  .cropper-canvas,
  .cropper-drag-box,
  .cropper-crop-box,
  .cropper-modal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .cropper-wrap-box {
    overflow: hidden;
  }
  .cropper-drag-box {
    opacity: 0;
    background-color: #fff;
  }
  .cropper-modal {
    opacity: .5;
    background-color: #000;
  }
  .cropper-view-box {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
  }

  .cropper-dashed {
    position: absolute;
    display: block;
    opacity: .5;
    border: 0 dashed #eee
  }
  .cropper-dashed.dashed-h {
    top: 33.33333%;
    left: 0;
    width: 100%;
    height: 33.33333%;
    border-top-width: 1px;
    border-bottom-width: 1px
  }
  .cropper-dashed.dashed-v {
    top: 0;
    left: 33.33333%;
    width: 33.33333%;
    height: 100%;
    border-right-width: 1px;
    border-left-width: 1px
  }
  .cropper-center {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 0;
    height: 0;
    opacity: .75
  }
  .cropper-center:before,
  .cropper-center:after {
    position: absolute;
    display: block;
    content: ' ';
    background-color: #eee
  }
  .cropper-center:before {
    top: 0;
    left: -3px;
    width: 7px;
    height: 1px
  }
  .cropper-center:after {
    top: -3px;
    left: 0;
    width: 1px;
    height: 7px
  }
  .cropper-face,
  .cropper-line,
  .cropper-point {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    opacity: .1;
  }
  .cropper-face {
    top: 0;
    left: 0;
    background-color: #fff;
  }
  .cropper-line {
    background-color: #39f
  }
  .cropper-line.line-e {
    top: 0;
    right: -3px;
    width: 5px;
    cursor: e-resize
  }
  .cropper-line.line-n {
    top: -3px;
    left: 0;
    height: 5px;
    cursor: n-resize
  }
  .cropper-line.line-w {
    top: 0;
    left: -3px;
    width: 5px;
    cursor: w-resize
  }
  .cropper-line.line-s {
    bottom: -3px;
    left: 0;
    height: 5px;
    cursor: s-resize
  }
  .cropper-point {
    width: 5px;
    height: 5px;

    opacity: .75;
    background-color: #39f
  }
  .cropper-point.point-e {
    top: 50%;
    right: -3px;
    margin-top: -3px;
    cursor: e-resize
  }
  .cropper-point.point-n {
    top: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: n-resize
  }
  .cropper-point.point-w {
    top: 50%;
    left: -3px;
    margin-top: -3px;
    cursor: w-resize
  }
  .cropper-point.point-s {
    bottom: -3px;
    left: 50%;
    margin-left: -3px;
    cursor: s-resize
  }
  .cropper-point.point-ne {
    top: -3px;
    right: -3px;
    cursor: ne-resize
  }
  .cropper-point.point-nw {
    top: -3px;
    left: -3px;
    cursor: nw-resize
  }
  .cropper-point.point-sw {
    bottom: -3px;
    left: -3px;
    cursor: sw-resize
  }
  .cropper-point.point-se {
    right: -3px;
    bottom: -3px;
    width: 20px;
    height: 20px;
    cursor: se-resize;
    opacity: 1
  }
  @media (min-width: 768px) {
    .cropper-point.point-se {
      width: 15px;
      height: 15px
    }
  }
  @media (min-width: 992px) {
    .cropper-point.point-se {
      width: 10px;
      height: 10px
    }
  }
  @media (min-width: 1200px) {
    .cropper-point.point-se {
      width: 5px;
      height: 5px;
      opacity: .75
    }
  }
  .cropper-point.point-se:before {
    position: absolute;
    right: -50%;
    bottom: -50%;
    display: block;
    width: 200%;
    height: 200%;
    content: ' ';
    opacity: 0;
    background-color: #39f
  }
  .cropper-invisible {
    opacity: 0;
  }
  .cropper-bg {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
  }
  .cropper-hide {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
  }
  .cropper-hidden {
    display: none !important;
  }
  .cropper-move {
    cursor: move;
  }
  .cropper-crop {
    cursor: crosshair;
  }
  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }

  .inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  .inputfile+label {
    // height: 30px;
    // padding: 7px 21px;
    // font-size: 14px;
    color: #354052; // text-align: center;
    background-color: #FFFFFF;
    border: 1px dashed #D8DFE5;
    border-radius: 4px;
    display: inline-block;
    cursor: pointer;
    /* 小手光标*/
  }
  .inputfile:focus+label,
  .inputfile+label:hover {
    // background-color: #E7F2FF;
    color: #3488FF;
    border: 1px dashed #BADBFF;
  }
}
</style>
